export default "__VITE_ASSET__b01c94fd__"